import React from 'react';
import Image from '../../../../commonComponents/image/Image';
import { imageSet } from '../../../../helper/Images';
import PropTypes from 'prop-types';

const MakeupCategory = ({
  category,
  makeupIndex,
  categoryIndex,
  onClick,
  makeupCleared,
}) => {
  const { name, type } = category;
  const active = makeupIndex === categoryIndex && !makeupCleared;
  return (
    <li
      key={name}
      className={active ? 'palette--item active' : 'palette--item'}
      onClick={() => onClick(categoryIndex)}
    >
      <figure className="palette--item__image-wrapper">
        <figcaption className="palette--item__image-name">{name}</figcaption>
        <Image className="palette--item__image-lens" src={imageSet[type]} />
      </figure>
    </li>
  );
};

MakeupCategory.propTypes = {
  category: PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.string,
  }),
  makeupIndex: PropTypes.number,
  categoryIndex: PropTypes.number,
  makeupCleared: PropTypes.bool,
  onClick: PropTypes.func,
};

export default MakeupCategory;
